import { Pipe, PipeTransform } from '@angular/core'
import { format, toZonedTime } from 'date-fns-tz'

@Pipe({
  name: 'britishDate',
})
export class BritishDatePipe implements PipeTransform {
  transform(value: Date | string | number | null, pattern = 'd MMM y HH:mm'): string {
    if (value === null) {
      return ''
    }
    const timeZone = 'Europe/London'
    const date = typeof value === 'string' || typeof value === 'number' ? new Date(value) : value
    const zonedDate = toZonedTime(date, timeZone)
    return format(zonedDate, pattern, { timeZone })
  }
}
